import React from "react";

const About = () =>{
  return(
     <section className="about">
       <div className="about__inner">
         <h1 className="about__headline">
           Psych Table is the first international collaborative endeavor to classify the evolved mechanisms of the human mind.
         </h1>
         <a href="https://translate.google.com/" className="about__link">Read more</a>
       </div>
     </section>
  )
};

export default About;
